export default "__VITE_ASSET__DUL2vJTP__"